import { Controller } from 'stimulus';
import flatpickr from 'flatpickr';

export default class extends Controller {
	static targets = ["startTime"]

	connect() {
		flatpickr('#startTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		});

		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		});
	}

	selectStartTime() {
		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: this.startTimeTarget.value,
			dateFormat: 'Y-m-d H:i',
		});
	}

	reset() {
		flatpickr('#startTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		}).clear();

		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		}).clear();
	}
}
